module.exports = __webpack_public_path__ + "static/media/front108.37ad3e1f.jpg";